import _findIndex from 'lodash/findIndex';

const handleKeyDown = (props, ref, vertical = false) => (event) => {
  const { onKeyDown } = props;
  onKeyDown && onKeyDown(event);
  const { key } = event;
  const elements = ref.current.querySelectorAll('.ccfk-tabs-tabable');
  const numberOfElements = elements.length;
  const first = elements[0];
  const last = elements[numberOfElements - 1];
  const current = document.activeElement;
  const shouldNotFocus = element => !element.classList.contains('ccfk-tabs-tabable') || element.disabled;
  const currentIndex = _findIndex(elements, elem => elem.contains(current));
  const prevItem = itemIndex => itemIndex > 0 && elements[itemIndex - 1];
  const nextItem = itemIndex => itemIndex < numberOfElements && elements[itemIndex + 1];
  const shiftFocus = (currentItem, traverse = () => {}, direction) => {
    let loopedOnce = false;
    let nextFocus = traverse(currentItem);
    while (nextFocus) {
      if (nextFocus === first) {
        if (loopedOnce) return false;
        loopedOnce = true;
      }
      if (shouldNotFocus(nextFocus)) {
        nextFocus = traverse(nextFocus);
      } else {
        nextFocus.focus();
        return true;
      }
    }
    if (!nextFocus) {
      if (direction === 'first') first && first.focus();
      if (direction === 'last') last && last.focus();
      return true;
    }
    return false;
  };

  switch (key) {
    case 'ArrowLeft':
      event.preventDefault();
      shiftFocus(currentIndex, prevItem, 'prev');
      break;
    case 'ArrowRight':
      event.preventDefault();
      shiftFocus(currentIndex, nextItem, 'next');
      break;
    case 'Home':
      event.preventDefault();
      shiftFocus(currentIndex, undefined, 'first');
      break;
    case 'End':
      event.preventDefault();
      shiftFocus(currentIndex, undefined, 'last');
      break;
    default:
      break;
  }
  if (vertical) {
    switch (key) {
      case 'ArrowUp':
        event.preventDefault();
        shiftFocus(currentIndex, prevItem, 'prev');
        break;
      case 'ArrowDown':
        event.preventDefault();
        shiftFocus(currentIndex, nextItem, 'next');
        break;
      default:
        break;
    }
  }
};
export default handleKeyDown;